import { Suspense, lazy } from 'react';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';

const WhatIsVoyara = lazy(() => import('../components/WhatIsVoyara'));
const Technology = lazy(() => import('../components/Technology'));

export default function TravelIntelligence() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Travel Intelligence & Technology | Voyara AI",
    "description": "Deep dive into Voyara AI's travel intelligence technology, predictive buffer engine, and intelligent coordination systems."
  };

  return (
    <main className="relative z-10 pt-20">
      <SEO 
        title="Travel Intelligence Technology — Voyara AI"
        description="Deep dive into Voyara AI's travel intelligence technology, predictive buffer engine, and intelligent coordination systems."
        canonical="https://www.eclipsegroup.in/travel-intelligence"
        schema={schema}
      />
      {/* Same inline padding as the .section-padding sections below, so the
          trail lines up with their content. */}
      <div className="pt-12 px-[clamp(24px,4vw,64px)]">
        <div className="global-container">
          <Breadcrumbs trail={[{ name: 'Travel Intelligence', path: '/travel-intelligence' }]} className="" />
        </div>
      </div>
      {/* The reused home-page sections start at h2; the page needs its own h1. */}
      <h1 className="sr-only">Voyara AI Travel Intelligence Technology</h1>

      <Suspense fallback={<div className="h-64 flex items-center justify-center"><div className="w-4 h-4 rounded-full border-2 border-white/10 border-t-white/50 animate-spin" /></div>}>
        <WhatIsVoyara />
        <div className="relative h-20">
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-transparent" />
        </div>
        <Technology />
      </Suspense>
    </main>
  );
}
